import api from "./api";

export const getAllLegalPages = async () => {
    try {
        const response = await api.get(`/pages`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching legal page:', error);
        return null;
    }
};

export const getLegalPage = async (slug) => {
    try {
        const response = await api.get(`/pages?filters[slug][$eq]=${slug}&populate=*`);
        return response.data.data[0];
    } catch (error) {
        console.error('Error fetching legal page:', error);
        return null;
    }
};